import { IBrandOrder } from "@faire/web-api/indigofair/data/IBrandOrder";
export var isBrandOrderBackordered = function isBrandOrderBackordered(selectedBrandOrder) {
  return selectedBrandOrder.state === IBrandOrder.State.BACKORDERED || selectedBrandOrder.exception_reason === IBrandOrder.ExceptionReason.BACKORDERED_ITEMS || selectedBrandOrder.backordered_at;
};